import React from "reactn";
import { withRouter } from "react-router-dom"
import { NewTabbedTable } from "../../components/UI";
import { format } from "date-fns";
import { Link } from "react-router-dom";
import { MiniPlus } from "../../assets";
import axios from "axios";
import CancelModal from "../../components/modals/CancelModal";
import Reschedule from "../../components/modals/RescheduleModal";
import AppointmentDetailsModal from "../../components/modals/AppointmentDetailsModal";
import InviteModal from "../../components/modals/AppointmentInviteModal";
class TourRequests extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        Active: [],
        Expired: []
      },
      selectedMessage: null
    };

    this.setGlobal({
      partnerPathway: [
        ...this.global.partnerPathway.slice(0, 1),
        { label: "Appointments", to: "/appointments" }
      ]
    });
    this.tabs = ["Active", "Expired"];
    this.headings = [
        {
          id: "displayName",
          label: "Parent",
          customCell: (r, i) => (
            <td
              key={`${i}-name`}
              style={{
                fontFamily: "Open Sans, sans-serif",
                fontWeight: 400,
                fontSize: "13px",
                lineHeight: "19px",
                color: "#000000",
                padding: "15px"
              }}
            >
              {r.displayName}
            </td>
          )
        },
        {
          id: "requestedTourDate",
          label: "Requested Date",
          customCell: this.dateCell
        },
        {
          id: "phone",
          label: "Cell Phone",
          customCell: (r, i) => (
            <td
              key={`${i}-phone`}
              style={{
                fontFamily: "Open Sans, sans-serif",
                fontWeight: 400,
                fontSize: "13px",
                lineHeight: "19px",
                color: "#000000",
                padding: "15px"
              }}
            >
              {r.phone}
            </td>
          )
        },
        {
          id: "email",
          label: "Email",
          customCell: (r, i) => (
            <td
              key={`${i}-email`}
              style={{
                fontFamily: "Open Sans, sans-serif",
                fontWeight: 400,
                fontSize: "13px",
                lineHeight: "19px",
                color: "#000000",
                padding: "15px"
              }}
            >
              {r.email}
            </td>
          )
        },
        {
          id: "type",
          label: "Type",
          customCell: (r, i) => (
            <td
              key={`${i}-type`}
              style={{
                fontFamily: "Open Sans, sans-serif",
                fontWeight: 400,
                fontSize: "13px",
                lineHeight: "19px",
                color: "#000000",
                padding: "15px"
              }}
            >
              {r.type}
            </td>
          )
        },
        {
          id: "location",
          label: "Method",
          customCell: (r, i) => (
            <td
              key={`${i}-location`}
              style={{
                fontFamily: "Open Sans, sans-serif",
                fontWeight: 400,
                fontSize: "13px",
                lineHeight: "19px",
                color: "#000000",
                padding: "15px",
                minWidth: "150px"
              }}
            >
              {r.location}
            </td>
          )
        },
        {
          id: "accepted",
          label: "Status",
          customCell: this.acceptedCell
        },
        {
          id: "details",
          label: "",
          customCell: this.details
        },
        {
          id: "accept",
          label: "",
          customCell: this.acceptNow,
          customStyle: { width: 180 }
        }

        /*{
          id: "cancel",
          label: "",
          customCell: this.cancelTourCell,
          customStyle: { width: 180 }
        }*/
      ]
  }
  acceptTour = async r => {
    this.setGlobal({ loading: true });
    const ep = `${process.env.REACT_APP_API}/partners/appointments/accept`;
    const result = await axios.post(ep, {
      ...r
    });
    this.setGlobal({ loading: false });
    if (result.data.success) {
      this.setState({
        data: {
          Active: this.state.data["Active"].map(e =>
            e.id === result.data.data.id
              ? { ...e, accepted: result.data.data.accepted }
              : e
          )
        }
      });
    }
  };

  sendInvite = r => {
    this.props.history.push({
      pathname: "/partners/send-message",
      type: "partner_appointments",
      selectedOption: r.id,
      appt: {
        displayName: r.displayName,
        email: r.email,
        phone: r.phone,
        stage: null,
        dsUserId: r.parentId
      }
    });
  };

  cancelTourCell = (r, i) => {
    if (new Date(r["Appointment Time"]).getTime() > Date.now() && !r.canceled) {
      return (
        <td key={`${i}-btn`}>
          <button
            style={{
              fontFamily: "Open Sans, sans-serif",
              fontWeight: 600,
              fontSize: "12px", // Match Accepted cell font size
              lineHeight: "19px",
              padding: "3px 15px", // Match Accepted cell padding
              transition: "all 0.15s ease",
              border: 0,
              margin: "0 1px"
            }}
            className="btn btn-danger"
            onClick={() =>
              this.setState({ cancelModalOpen: true, tourCancel: r })
            }
          >
            CANCEL TOUR
          </button>
        </td>
      );
    }
    return <td key={`${i}-btn`} colSpan={1}></td>;
  };

  rescheduleTourCell = (r, i) => {
    if (new Date(r["Appointment Time"]).getTime() > Date.now() && !r.canceled) {
      return (
        <td key={`${i}-btn`}>
          <button
            style={{
              fontFamily: "Open Sans, sans-serif",
              fontWeight: 600,
              fontSize: "12px", // Match Accepted cell font size
              lineHeight: "19px",
              padding: "3px 15px", // Match Accepted cell padding
              transition: "all 0.15s ease",
              border: 0,
              margin: "0 1px"
            }}
            className={"btn btn-secondadry"}
            onClick={() =>
              this.setState({ rescheduleModalOpen: true, tourReschedule: r })
            }
          >
            RESCHEDULE
          </button>
        </td>
      );
    }
    return <td key={`${i}-btn`} colSpan={1}></td>;
  };

  acceptNow = (r, i) => {
    if (
      new Date(r["Appointment Time"]).getTime() > Date.now() &&
      !r.accepted &&
      !r.canceled &&
      parseInt(r.rescheduledBy) !== this.global.dsUser.id
    ) {
      return (
        <td key={`${i}-btn`}>
          <button
            onClick={() => this.acceptTour(r)}
            style={{
              fontFamily: "Open Sans, sans-serif",
              fontWeight: 600,
              fontSize: "12px", // Match Accepted cell font size
              lineHeight: "19px",
              padding: "3px 15px", // Match Accepted cell padding
              transition: "all 0.15s ease",
              border: 0,
              margin: "0 1px"
            }}
            className="btn btn-success"
          >
            ACCEPT
          </button>
        </td>
      );
    } else if (       
      new Date(r["Appointment Time"]).getTime() > Date.now() &&
      !r.canceled &&
      parseInt(r.rescheduledBy) !== this.global.dsUser.id
    ) {
      return (
        <td key={`${i}-btn`}>
          <button
            onClick={() => this.sendInvite(r)}
            style={{
              fontFamily: "Open Sans, sans-serif",
              fontWeight: 600,
              fontSize: "12px", // Match Accepted cell font size
              lineHeight: "19px",
              padding: "3px 15px", // Match Accepted cell padding
              transition: "all 0.15s ease",
              border: 0,
              margin: "0 1px",
              width: "110px"
            }}
            className="btn btn-success"
          >
            Send Details
          </button>
        </td>
      );
    }
    return <td key={`${i}-btn`} colSpan={1}></td>;
  };

  acceptedCell = (r, i) => {
    let color = "";
    let text = "";

    if (r.canceled) {
      color = "#ff3b8e";
      text = `Canceled by: ${r.canceledBy}`;
    } else if (r.accepted) {
      color = "#1bc88a";
      text = "Accepted";
    } else if (Date.now() > new Date(r["Appointment Time"]).getTime()) {
      color = "#d3d3d3";
      text = "Expired";
    } else {
      color = "#eba93e";
      text = "Pending";
    }

    return (
      <td
        key={`${i}-${r.id}-acc`}
        style={{
          fontFamily: "Open Sans, sans-serif",
          fontWeight: 400,
          fontSize: "12px",
          lineHeight: "19px",
          color: "#000000",
          padding: "15px",
          verticalAlign: "top" // Align the text to the top instead of the center
        }}
      >
        <div
          style={{
            textAlign: "right",
            display: "flex"
          }}
        >
          <span
            style={{
              minWidth: "100px",
              background: color,
              padding: "3px",
              borderRadius: "13px",
              color: "white",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              fontFamily: "Open Sans",
              fontSize: "12px",
              fontWeight: 600,
            }}
          >
            {text}
          </span>
        </div>
      </td>
    );
  };

  details = (r, i) => {
    return (
      <td key={`${i}-${r.id}-det`}>
        <button
          style={{
            fontFamily: "Open Sans, sans-serif",
            fontWeight: 600,
            fontSize: "12px", // Match Accepted cell font size
            lineHeight: "19px",
            padding: "3px 15px", // Match Accepted cell padding
            transition: "all 0.15s ease",
            border: 0,
            margin: "0 1px",
            width: "110px"
          }}
          className="btn btn-info"
          onClick={() =>
            this.setState({
              detailsModalShown: true,
              modalData: r,
              selectedMessage: r.Message
            })
          }
        >
          View Details
        </button>
      </td>
    );
  };

  dateCell = (r, i) => {
    return (
      <td
        key={`${i}-${r.id}`}
        style={{
          fontFamily: "Open Sans, sans-serif",
          fontWeight: 400,
          fontSize: "13px",
          lineHeight: "19px",
          color: "#000000",
          padding: "15px",
          minWidth: "200px"
        }}
      >
        {format(new Date(r["Appointment Time"]), "LLL dd, yyyy")}<br />
        {format(new Date(r["Appointment Time"]), "h:mm aaaa")} - {format(new Date(r["Appointment End"]), "h:mm aaaa")}
      </td>
    );
  };

  async componentDidMount() {
    const ep = `${process.env.REACT_APP_API}/partners/appointments`;
    try {
      this.setGlobal({ loading: true });
      const res = await axios.get(ep);
      if (res.data.success) {
        console.log(res.data.data);
        let active = [];
        let expired = [];
        res.data.data.map(appt => {
          let dateOffset = new Date();
          dateOffset.setDate(dateOffset.getDate() - 3); // add 72 hours for non-accepted pending
          if (appt.cancled || 
            (Date.now() > new Date(appt["Appointment End"]).getTime() && appt.accepted) || // Accepted and in the past
            (dateOffset.getTime() > new Date(appt["Appointment End"]).getTime() && !appt.accepted)) // non-accepted and past 3 day offset
            {
              expired.push(appt);
            } else {
              active.push(appt);
            }
        })
        this.setState({
          data: {
            Active: active,
            Expired: expired
          }
        });
      }


      this.setGlobal({ loading: false, lastAPICall: res });
    } catch (ex) {
      this.setGlobal({ loading: false, lastAPICall: null });
    }
  }

  /**
   * This function handles the edit button functionality of a sub user
   * returns a boolean value
   */
  canSubUserEdit = () => {
    return !(!this.global.dsUser.sub_user ||
      this.global?.dsUser?.accesspoints?.Leads?.Appointments?.edit);
  };

  render() {
    return (
      <div className="container-fluid">
        <div className="cont">
          <div className="row">
            <div className="col-md-6">
              <h1 style={{
                fontSize: window.innerWidth < 768 ? "1.5rem" : "2rem"
              }}>Appointment Requests</h1>
            </div>
            {this.state.detailsModalShown && (
              <AppointmentDetailsModal
                message={this.state.selectedMessage}
                onClose={() =>
                  this.setState({
                    detailsModalShown: false
                  })
                }
              />
            )}
            {this.state.inviteModalShown && (
              <InviteModal
                onClose={() => this.setState({ inviteModalShown: false })}
              />
            )}
            <div className="col-md-6">
              <div className="forbtnwrap justify-end">
              <div className="forbtnapp">
                  <button
                    className="newapplications"
                    disabled={this.canSubUserEdit()}
                    style={{
                      cursor: this.canSubUserEdit()
                        ? "not-allowed"
                        : "pointer",
                        transform: `scale(${window.innerWidth < 768 ? 0.8 : 1})`,
                      transformOrigin: "left center"
                    }}
                    onClick={_ => {
                      this.setState({ inviteModalShown: true });
                    }}
                  >
                    <img
                      src={MiniPlus}
                      alt=""
                      style={{ alignSelf: "center", transform: `scale(${window.innerWidth < 768 ? 0.8 : 1})`,
                        transformOrigin: "left center" }}
                    />
                    Invite
                  </button>
                </div>
                <div
                  className="forbtnapp"
                  style={{
                    cursor: this.canSubUserEdit() ? "not-allowed" : "pointer",
                    marginLeft: window.innerWidth < 768 ? "5px" : "20px",
                    transform: `scale(${window.innerWidth < 768 ? 0.8 : 1})`,
                    transformOrigin: "left center"
                  }}
                >
                  <Link
                    to="/partners/appointments/availability"
                    className="newapplications"
                    disabled={this.canSubUserEdit()}
                    style={{
                      whiteSpace: "nowrap",
                    }}
                  >
                    Appointments Availability
                  </Link>
                </div>

              </div>
            </div>
          </div>
        </div>
        <div className="cont">
          <NewTabbedTable
            tabs={this.tabs}
            headings={{Active: this.headings, Expired: this.headings}}
            data={this.state.data}
            // actions={this.actions}
          />
        </div>
        {this.state.cancelModalOpen && (
          <CancelModal
            tour={this.state.tourCancel}
            openSchedule={() => this.setState({ rescheduleModalOpen: true })}
            onClose={() => this.setState({ cancelModalOpen: false })}
          />
        )}
        {this.state.rescheduleModalOpen && (
          <Reschedule
            tour={this.state.tourReschedule}
            onClose={() => this.setState({ rescheduleModalOpen: false })}
          />
        )}
      </div>
    );
  }
}

export default withRouter(TourRequests);
